import { useEffect, useState } from 'react'
import FormDrawer from '../../common/form-drawer'
import usePayrollEssentials from 'hooks/usePayrollEssentials';
import { assignAllowancePayGroups, getAllowances, getPayGroups, toggleAllowanceGroupAssignment } from 'store/entities/payroll/payrollSetup/action';
import iconSearch from "assets/images/icons/icon-search.svg";
import Spinner from 'components/__new/common/Spinner';
import Maybe from 'components/__new/common/Maybe';
import successGif from "assets/images/icons/success-green.gif";

const AllowancePayGroupsAssignmentModal = ({ allowance }) => {
const [search, setSearch] = useState("");
const {dispatch, useSelector} = usePayrollEssentials()

const { selectedAllowance, assignAllowanceGroupsLoading: updateLoading, getPayGroupData, getPayGroupLoading, isAllowanceQuickAssignModalOpen, assignAllowancePayGroup } = useSelector(state => state.entities.payrollSetup)
const [selected, setSelected] = useState([]);
const [isSuccess, setIsSuccess] = useState(false);

const allPayGroupIDs = getPayGroupData?.data?.map((item) => item.id);
const allItemsSelected = selected?.length === getPayGroupData?.data?.length;

const filteredItems = getPayGroupData?.data?.filter(item => {
    if(search === "") {
        return true
    } else {
        return item?.name?.toLowerCase()?.includes(search?.toLowerCase())
    }
})

const toggleSelection = (id) => {
    if(selected?.includes(id)) {
        const newItems = selected?.filter((item) => item !== id)
        setSelected(newItems)
    } else {
        setSelected([...selected, id])
    }
}

const toggleSelectAll = () => {
    if(allItemsSelected) {
        setSelected([]);
    } else {
        setSelected(allPayGroupIDs)
    }
}

const clearAndClose = () => {
    setSearch("")
    dispatch(toggleAllowanceGroupAssignment())
    setSelected([]);
}

const onProceed = () => {
    
    const payload = {
        allowance_and_bonus_id: selectedAllowance?.id || allowance?.id,
        pay_group_ids: selected
    }
    dispatch(assignAllowancePayGroups(payload));
}

useEffect(() => {
    if (assignAllowancePayGroup?.length > 0) {
        setIsSuccess(true);
        clearAndClose();
        dispatch(getAllowances({ "page": 1, "limit": 10 }));
    }
}, [assignAllowancePayGroup])

useEffect(() => {
    dispatch(getPayGroups({page: 1}));
    // eslint-disable-next-line
}, [])

    return (
        <>
            <Maybe condition={isSuccess}>
                <FormDrawer display="center" size="lg" isOpen={isSuccess} 
                    setIsOpen={setIsSuccess}
                >
                    <div className="p-6">
                        <div className="flex justify-center">
                            <div className="h-48 sm:h-56">
                                <img src={successGif} alt="Success" className="h-full object-contain mx-auto" />
                            </div>
                        </div>

                        <div className="mt-4 py-2">
                            <div className="text-center text-[#4A5564] font-normal text-lg">
                                {/* Allowance and Bonus has been assigned to {selected?.length} group{selected?.length > 1 ? "s" : ""} */}
                                Allowance and Bonus assigned successfully.
                            </div>
                        </div>

                        <div className="py-2 mt-4 flex justify-center gap-6">
                            <button type="button" className="btn btn-lg btn-block rounded-lg whitespace-nowrap text-white bg-ep-primary-600" onClick={() => {            
                                setSelected([]);
                                setIsSuccess(false)
                            }}>
                                Close
                            </button>
                        </div>
                    </div>
                </FormDrawer>
            </Maybe>
        <FormDrawer display="center" size="lg" isOpen={isAllowanceQuickAssignModalOpen} setIsOpen={clearAndClose}>
            <Maybe condition={getPayGroupLoading || updateLoading}>
                <Spinner message={updateLoading ? "Updating..." : "Fetching Pay Groups"} />
            </Maybe>

            <Maybe condition={getPayGroupLoading === false && updateLoading === false}>
                <div className="p-7 w-full">
                    <div className="mb-5">
                        <p className="mb-1 font-semibold">Assign Group</p>
                        <span className="text-[#121619] text-sm capitalize">
                            Assign <span className='font-medium'>"{selectedAllowance?.name || allowance?.name}"</span> to Groups
                        </span>
                    </div>

                    <div className="my-7">
                        <div className="form-group-icon h-10 rounded-md border">
                            <label htmlFor="search">
                                <img src={iconSearch} alt="Search" className="form-group-icon-attach h-4" />
                            </label>
                            <input
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                placeholder="Search employees"
                                className="w-full border h-full form-input-icon focus:ring-transparent"
                                style={{paddingLeft: "0",  outline: "none"}}
                            />
                        </div>

                        <div className="flex items-center justify-end pt-6 text-[#6c757d] text-sm pr-[14px]">
                            <div className="mr-3">{selected?.length} selected</div>| &nbsp;
                            <button onClick={toggleSelectAll} className="flex items-center cursor-pointer">
                                {allItemsSelected ? "Deselect" : "Select"} all &nbsp; 
                                <input
                                    onChange={() => null}
                                    checked={allItemsSelected || false}
                                    type="checkbox" 
                                    className="w-4 h-4 ml-2 form-checkbox float-left"
                                />
                            </button>
                        </div>

                        <div style={{maxHeight: '300px'}} className="overflow-y-scroll modal-list-wrap mt-6">
                            {filteredItems?.map((item, index) => {
                                const isSelected = selected?.includes(item?.id)
                                return <div onClick={() => toggleSelection(item.id)} key={index}
                                            className={`flex items-start justify-between border rounded-md p-3.5 mb-5 cursor-pointer ${isSelected && "border-ep-primary-600"}`}>
                                        <div>
                                            <p className="capitalize mb-1 font-medium tracking-wide flex items-center">
                                                {item.name.toLowerCase()}
                                            </p>
                                            <p className="text-xs lt-gray mb-0">
                                                {item?.employees?.length} employees
                                            </p>
                                        </div>
                                        <div className="flex items-center justify-center">
                                        <input
                                            onChange={() => null}
                                            checked={selected?.includes(item?.id) || false}
                                            type="checkbox" 
                                            className="w-4 h-4 ml-2 form-checkbox float-left"
                                        />
                                        </div>
                                </div>
                            })}
                        </div>
                    </div>
                    <div className="w-full flex items-center mt-12 justify-end">
                        <button onClick={clearAndClose} type='button' className="btn btn-md btn-transparent-primary mr-4 lg:mr-6">Cancel</button>
                        <button disabled={selected?.length < 1 || updateLoading} onClick={onProceed} className="btn btn-md btn-ep-primary">
                            Assign to Allowance
                        </button>
                    </div>
                </div>
            </Maybe>
            
        </FormDrawer>
        </>
    )
}

export default AllowancePayGroupsAssignmentModal